import {
  GET_EXPLORE_ITEMS_REQUEST,
  GET_EXPLORE_ITEMS_SUCCESS,
  GET_EXPLORE_ITEMS_FAILURE,
  LOAD_MORE_RESULTS_REQUEST,
  LOAD_MORE_RESULTS_SUCCESS,
  LOAD_MORE_RESULTS_FAILURE,
  GET_EXPLORE_CONVERSATION_ITEMS_REQUEST,
  GET_EXPLORE_CONVERSATION_ITEMS_FAILURE,
  GET_EXPLORE_CONVERSATION_ITEMS_SUCCESS,
  GET_SAVED_QUERIES_REQUEST,
  GET_SAVED_QUERIES_SUCCESS,
  GET_SAVED_QUERIES_FAILURE,
  LOAD_MORE_SAVED_QUERIES_REQUEST,
  LOAD_MORE_SAVED_QUERIES_SUCCESS,
  LOAD_MORE_SAVED_QUERIES_FAILURE,
  CLEAR_ALL_QUERIES_REQUEST,
} from '../../constants/action-types';

const setQ = (state, actionParams) => {
  if (!actionParams) {
    return state.params.q;
  }

  if (actionParams.q && actionParams.q.length > 0) {
    return actionParams.q;
  }

  if (actionParams.q === '') {
    return '';
  }

  return state.params.q;
};

const setCategoryId = (state, actionParams) => {
  if (!actionParams || !actionParams.categoryId) {
    return state.params.categoryId;
  }

  if (actionParams.categoryId === 'all') {
    return '';
  }

  if (actionParams.categoryId && actionParams.categoryId.length > 0) {
    return actionParams.categoryId;
  }
};

const setQueryType = (state, actionParams) => {
  if (!actionParams || !actionParams.queryType) {
    return state.params.queryType;
  }

  if (actionParams.queryType === 'all') {
    return '';
  }

  if (actionParams.queryType && actionParams.queryType.length > 0) {
    return actionParams.queryType;
  }
};

const setVariableTypes = (state, actionParams) => {
  if (!actionParams || !actionParams.variableTypes) {
    return state.params.variableTypes;
  }

  if (actionParams.variableTypes === 'all') {
    return 'item,category,psychographic,demographic';
  }

  return actionParams.variableTypes;
};

const setSources = (state, actionParams) => {
  if (!actionParams || !actionParams.sources) {
    return state.params.sources;
  }

  return actionParams.sources;
};

const getInitialState = () => {
  return {
    isLoading: true,
    isLoadingMore: false,
    data: [],
    error: false,
    params: {
      q: '',
      categoryId: '',
      variableTypes: 'item,category',
      pagination: {
        page: 1,
        limit: 20,
      },
      queryType: '',
    },
  };
};

const setLoadMoreData = (state, data) => {
  const results = [...state.data, ...data];
  return results;
};

const getExplorerItemsFromConversations = data => {
  return [
    ...data.map(item => {
      const membershipId = item.metadata && item.metadata.target_membership_id;
      return {
        id: membershipId,
        label: item.label,
        taxonomy: [],
        type: 'membership',
        class: 'conversation',
      };
    }),
  ];
};

const initialState = getInitialState();

const getPaginationForConversationExplorerItems = (loadMore, state) => {
  if (loadMore) {
    return {
      ...state.params.pagination,
      page: state.params.pagination.page + 1,
    };
  }

  return {
    ...initialState.params.pagination,
  };
};

const exploreItems = (state = initialState, action) => {
  const types = {
    [GET_EXPLORE_ITEMS_REQUEST]: () => ({
      ...state,
      isLoading: true,
      isLoadingMore: false,
      params: {
        ...state.params,
        q: setQ(state, action.params),
        categoryId: setCategoryId(state, action.params),
        variableTypes: setVariableTypes(state, action.params),
        pagination: {
          ...initialState.params.pagination,
        },
        sources: setSources(state, action.params),
      },
    }),
    [GET_EXPLORE_ITEMS_SUCCESS]: () => ({
      ...state,
      isLoading: false,
      error: false,
      totalPageCount: Math.ceil(
        action.total_count / initialState.params.pagination.limit
      ),
      data: [...action.response],
    }),
    [GET_EXPLORE_ITEMS_FAILURE]: () => ({
      ...state,
      isLoading: false,
      error: true,
      message: action.message,
    }),
    [LOAD_MORE_RESULTS_REQUEST]: () => ({
      ...state,
      isLoadingMore: true,
      params: {
        ...state.params,
        pagination: {
          ...state.params.pagination,
          page: state.params.pagination.page + 1,
        },
      },
    }),
    [LOAD_MORE_RESULTS_SUCCESS]: () => ({
      ...state,
      isLoadingMore: false,
      data: setLoadMoreData(state, action.data),
    }),
    [LOAD_MORE_RESULTS_FAILURE]: () => ({
      ...state,
      isLoadingMore: false,
    }),
    [GET_EXPLORE_CONVERSATION_ITEMS_REQUEST]: () => ({
      ...state,
      isLoading: true,
      isLoadingMore: false,
      params: {
        ...state.params,
        q: setQ(state, action.params),
        pagination: getPaginationForConversationExplorerItems(
          action.loadMore,
          state
        ),
      },
    }),
    [GET_EXPLORE_CONVERSATION_ITEMS_SUCCESS]: () => ({
      ...state,
      isLoading: false,
      error: false,
      totalPageCount: Math.ceil(
        action.total_count / initialState.params.pagination.limit
      ),
      data: getExplorerItemsFromConversations(action.response),
    }),
    [GET_EXPLORE_CONVERSATION_ITEMS_FAILURE]: () => ({
      ...state,
      isLoading: false,
      error: true,
      message: action.message,
    }),
    [GET_SAVED_QUERIES_REQUEST]: () => ({
      ...state,
      isLoading: true,
      isLoadingMore: false,
      params: {
        q: setQ(state, action.params),
        queryType: setQueryType(state, action.params),
        pagination: {
          ...initialState.params.pagination,
        },
      },
    }),
    [GET_SAVED_QUERIES_SUCCESS]: () => ({
      ...state,
      isLoading: false,
      error: false,
      totalPageCount: Math.ceil(
        action.total_count / initialState.params.pagination.limit
      ),
      data: action.response,
    }),
    [GET_SAVED_QUERIES_FAILURE]: () => ({
      ...state,
      isLoading: false,
      error: true,
      message: action.message,
    }),
    [LOAD_MORE_SAVED_QUERIES_REQUEST]: () => ({
      ...state,
      isLoadingMore: true,
      params: {
        ...state.params,
        pagination: {
          ...state.params.pagination,
          page: state.params.pagination.page + 1,
        },
      },
    }),
    [LOAD_MORE_SAVED_QUERIES_SUCCESS]: () => ({
      ...state,
      isLoadingMore: false,
      data: setLoadMoreData(state, action.response),
    }),
    [LOAD_MORE_SAVED_QUERIES_FAILURE]: () => ({
      ...state,
      isLoadingMore: false,
    }),
    [CLEAR_ALL_QUERIES_REQUEST]: () => ({
      ...initialState,
    }),
  };

  if (!types[action.type]) {
    return state;
  }

  return types[action.type]();
};

export default exploreItems;
